import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "app-companies-list",
  templateUrl: "./companies-list.component.html",
  styleUrls: ["./companies-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CompaniesListComponent {
  @Input() companies = [];
  @Input() responsive = false;
  @Input() editable = false;
  @Output() edit = new EventEmitter<any>();
}
